// src/services/marketingCampaigns.service.js
import { request } from "./http";

const base = "/MarketingCampaigns";

// Backend expects DTO at ROOT (no { dto: ... } wrapper).
// quietHoursStart/End => TimeSpan format "HH:mm:ss"
const normalizeTime = (t) => {
  if (!t) return undefined;
  if (typeof t !== "string") return undefined;
  // "HH:mm" -> "HH:mm:ss"
  return t.length === 5 ? `${t}:00` : t;
};

// datetime-local => "YYYY-MM-DDTHH:mm" -> add seconds
const normalizeLocalDateTime = (v) => {
  if (!v) return undefined;
  if (typeof v !== "string") return undefined;
  return v.length === 16 ? `${v}:00` : v;
};

const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
};

const normalizeCreateDto = (dto) =>
  clean({
    campaignName: dto?.campaignName?.trim(),
    campaignType: dto?.campaignType?.trim(),
    channelType: dto?.channelType?.trim(),
    subject: dto?.subject?.trim(),
    content: dto?.content?.trim(),
    targetSegment: dto?.targetSegment?.trim() || undefined,
    sendFrequencyHours:
      dto?.sendFrequencyHours === "" || dto?.sendFrequencyHours == null
        ? undefined
        : Number(dto.sendFrequencyHours),
    quietHoursStart: normalizeTime(dto?.quietHoursStart),
    quietHoursEnd: normalizeTime(dto?.quietHoursEnd),
    scheduledDate: normalizeLocalDateTime(dto?.scheduledDate),
  });

const normalizeUpdateDto = (dto) =>
  clean({
    ...normalizeCreateDto(dto),
    status: dto?.status?.trim() || undefined,
  });

export async function listMarketingCampaigns() {
  return request(`${base}`, { method: "GET", auth: true });
}

export async function getMarketingCampaign(id) {
  return request(`${base}/${id}`, { method: "GET", auth: true });
}

export async function createMarketingCampaign(dto) {
  return request(`${base}`, {
    method: "POST",
    auth: true,
    body: normalizeCreateDto(dto),
  });
}

export async function updateMarketingCampaign(id, dto) {
  return request(`${base}/${id}`, {
    method: "PUT",
    auth: true,
    body: normalizeUpdateDto(dto),
  });
}

export async function deleteMarketingCampaign(id) {
  return request(`${base}/${id}`, { method: "DELETE", auth: true });
}

export async function sendMarketingCampaign(id) {
  return request(`${base}/${id}/send`, { method: "POST", auth: true });
}

// غالبًا unsubscribe public
export async function unsubscribeMarketingCampaign(payload) {
  return request(`${base}/unsubscribe`, {
    method: "POST",
    auth: false,
    body: payload,
  });
}

// Optional: object style compatibility
export const marketingCampaignsService = {
  listMarketingCampaigns,
  getMarketingCampaign,
  createMarketingCampaign,
  updateMarketingCampaign,
  deleteMarketingCampaign,
  sendMarketingCampaign,
  unsubscribeMarketingCampaign,
};
